//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapState  } from "vuex";
import logger from "@/utils/logger";

export default {
  data() {
    return {
      selectedSupplier: null,     
      registered: 0,
      ordered: 0,
      confirmed: 0,
      loading: true,
    };
  },
  async mounted() {  
    await this.fetchPurchaseData();           
  },

  watch: {
    selectedSupplier() {        
      this.fetchPurchaseData();        
    }
  },

computed: {
  ...mapState("main", ["suppliers"]),
  
  supplierOptions() {
    if (!this.suppliers || this.suppliers.length === 0) {
      logger.log("Ingen levrandører i state");
      return []
    }
    return this.suppliers.map(supplier => ({
      label: supplier.name,
      value: supplier.id
    }))
  },
  total() {
    return this.registered + this.ordered + this.confirmed
  }
},

  methods: {
    ...mapActions("main", ["getPurchaseValue"]),      

    formatAmount(amount) {
      return new Intl.NumberFormat('nb-NO', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount)
    },  

    async fetchPurchaseData() {
      this.loading = true;
      try {
        const data = await this.getPurchaseValue(this.selectedSupplier);

        this.registered = data.registeredSum || 0;
        this.ordered = data.orderSentSum || 0;
        this.confirmed = data.confirmedSum || 0;
      } catch (error) {
        logger.Log('Error fetching purchase data:', error);        
        this.registered = 0;
        this.ordered = 0;
        this.confirmed = 0;
      }
      finally {
        this.loading = false;
      }
    },
  },
};
